import {
  DEFAULT_CORE_BALANCE,
  installCoreBalance,
} from "./coreBalance.ts";
import {
  parseCoreBalanceOverride,
  resolveCoreBalance,
} from "./resolveCoreBalance.ts";

export const CORE_BALANCE_OVERRIDE_PATH = "/config/balance.override.json";

function isPresentJsonObjectPayload(response: Response, body: string): boolean {
  const contentType = response.headers.get("content-type") ?? "";
  if (contentType.includes("text/html")) {
    // Vite SPA fallback returns index.html with 200 when the file is absent.
    return false;
  }
  return body.trimStart().startsWith("{");
}

export async function loadAndInstallCoreBalance(): Promise<void> {
  installCoreBalance(DEFAULT_CORE_BALANCE);

  const response = await fetch(CORE_BALANCE_OVERRIDE_PATH);
  if (!response.ok) {
    return;
  }

  const json = await response.text();
  if (!isPresentJsonObjectPayload(response, json)) {
    return;
  }

  const patch = parseCoreBalanceOverride(json);
  installCoreBalance(resolveCoreBalance(DEFAULT_CORE_BALANCE, patch));
}
